import React from "react";
import { Route, Routes } from "react-router-dom";
import ShipmentCreateScreen from "screens/App/CRM/ShipmentRequest/ShipmentCreateScreen";
import ShipmentDetailScreen from "screens/App/CRM/ShipmentRequest/ShipmentDetailScreen";
import ShipmentEditScreen from "screens/App/CRM/ShipmentRequest/ShipmentEditScreen";
import ShipmentListScreen from "screens/App/CRM/ShipmentRequest/ShipmentListScreen";
import NotFoundScreen from "screens/NotFoundScreen";
import ImportExcelShipmentCreateScreen from "screens/App/CRM/ShipmentRequest/ShipmentComponents/ImportExcelShipmentCreateScreen";
import ShipmentReviewScreen from "screens/App/CRM/ShipmentRequest/ShipmentComponents/ShipmentReviewScreen";
import ShipmentPriceDetail from "screens/App/CRM/ShipmentRequest/ShipmentComponents/ShipmentPriceDetail";
import { BulkCancelScreen } from "screens/App/CRM/Contact/VendorProfile/Components/BulkCancelScreen";
import ShipmentAddCollectCreateScreen from "screens/App/CRM/ShipmentRequest/ShipmentAddCollectCreateScreen";
import ShipmentChartDetails from "components/Dashboard/ShipmentLineChartDetail";
import ShipmentPriceLineChartDetail from "components/Dashboard/ShipmentPriceLineChartDetail";
import ShipmentImportSummaryScreen from "screens/App/CRM/ShipmentRequest/ShipmentComponents/ShipmentImportSummaryScreen";
import ShipmentPrimaryStatusScreen from "screens/App/CRM/ShipmentRequest/ShipmentComponents/ShipmentPrimaryStatusScreen";

const ShipmentRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<ShipmentCreateScreen />} />
      <Route path="collect" element={<ShipmentAddCollectCreateScreen />} />

      <Route path="list" element={<ShipmentListScreen />} />
      <Route path="change-status-shipments" element={<ShipmentPrimaryStatusScreen />} />

      <Route
        path="importShipmentExcel/create"
        element={<ImportExcelShipmentCreateScreen />}
      />
      <Route
        path="importShipmentExcel/review"
        element={<ShipmentReviewScreen />}
      />

      <Route path="import-summary" element={<ShipmentImportSummaryScreen />} />
      <Route path="bulkCancelScreen" element={<BulkCancelScreen />} />

      <Route path=":id/detail" element={<ShipmentDetailScreen />} />
      <Route path="price/:priceId/detail" element={<ShipmentPriceDetail />} />

      <Route path=":id/edit" element={<ShipmentEditScreen />} />
      <Route path="/charts" element={<ShipmentChartDetails />} />
      <Route path="/price-charts" element={<ShipmentPriceLineChartDetail />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default ShipmentRouter;
